import type { RxJsonSchema } from 'rxdb';
import type { SignAndStampFile } from './signAndStamp.types';

export const signAndStampFileSchema: RxJsonSchema<SignAndStampFile> = {
  type: 'object',
  version: 1,
  description: 'describes sign and stamp files',
  primaryKey: 'fileUUID',
  properties: {
    fileId: { type: ['string', 'null'] },
    inspectionId: { type: ['string', 'null'] },
    fileUUID: { type: 'string', maxLength: 36 },
    fileCategory: { type: ['number', 'null'] },
    drawingType: { type: ['number', 'null'] },
    isImageFile: { type: ['boolean', 'null'] },
    pcsId: { type: ['string', 'null'] },
    sizeMb: { type: ['number', 'null'] },
    originalPath: { type: ['string', 'null'] },
    extension: { type: ['string', 'null'] },
    name: { type: ['string', 'null'] },
    originalFileName: { type: ['string', 'null'] },
    allowSpaccess: { type: ['boolean', 'null'] },
    legacyId: { type: ['number', 'null'] },
    fkAssetInspectionTask: { type: ['number', 'null'] },
    siteId: { type: ['number', 'null'] },
    disciplineId: { type: ['number', 'null'] },
    fileDescription: { type: ['string', 'null'] },
    showOnReport: { type: ['boolean', 'null'] },
    isDelete: { type: ['string', 'null'] },
    isSaveForFuture: { type: ['boolean', 'null'] },
    userId: { type: ['number', 'null'] },
    dateCreated: { type: ['string', 'null'] },
    dateModified: { type: ['string', 'null'] },
    leadInspectorName: { type: ['string', 'null'] },
    leadInspectorTitle: { type: ['string', 'null'] },
    leadDesignation: { type: ['string', 'null'] },
    leadCompanyName: { type: ['string', 'null'] },
    fieldInspectorName: { type: ['string', 'null'] },
    fieldInspectorTitle: { type: ['string', 'null'] },
    fieldDesignation: { type: ['string', 'null'] },
    fieldCompanyName: { type: ['string', 'null'] },
  },
};
